import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { MainConfig } from "@atenea-cms";

import { Product, ProductService } from "../shared";

@Component({
  selector: "product-list",
  templateUrl: "./product-list.component.html",
  styleUrls: ["./product-list.component.scss"],
})
export class ProductListComponent implements OnInit {
  products: Array<Product>;
  productsFiltered: Array<Product> = [];
  reorder: boolean = false;
  draggedItem: number = null;

  constructor(
    private titleService: Title,
    private mainConfig: MainConfig,
    private productService: ProductService
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Productos - " + this.mainConfig.cmsName);

    this.productService.getAll().subscribe((products) => {
      this.products = products;
    });
  }

  dragItem(e: Event, i: number) {
    e.stopPropagation();
    this.draggedItem = i;
  }

  dropItem(e: Event, i: number) {
    e.stopPropagation();
    this.productsFiltered = this.reorderItems(
      this.productsFiltered,
      this.draggedItem,
      i
    );
    this.draggedItem = null;
    this.productService.savePositions(this.productsFiltered).subscribe();
  }

  cancelDrag() {
    if (this.draggedItem !== null) {
      this.draggedItem = null;
    }
  }

  private reorderItems(
    items: Array<any>,
    positionStart: number = null,
    positionEnd: number = null
  ) {
    if (positionStart != positionEnd) {
      let itemsCloned = items.slice();
      let itemSelected = items[positionStart];
      items = [];

      itemsCloned.forEach((item, i) => {
        if (positionStart > positionEnd) {
          if (i > positionStart || i < positionEnd) {
            items[i] = item;
          } else if (i == positionEnd) {
            items[i] = itemSelected;
            items[i + 1] = item;
          } else if (i != positionStart) {
            items[i + 1] = item;
          }
        } else {
          if (i < positionStart || i > positionEnd) {
            items[i] = item;
          } else if (i == positionEnd) {
            items[i] = itemSelected;
            items[i - 1] = item;
          } else if (i != positionStart) {
            items[i - 1] = item;
          }
        }
      });
    }

    items = items.map((x, y) => {
      x.position = y + 1;

      return x;
    });

    return items;
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-list/product-list.component.ts